<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('capacity.capacityNumber')" prop="serialNo">
                  <!--产能编号-->
                  <el-input v-model.trim="queryCondition.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="emplFlag != 'SUP'">
                <el-form-item :label="$t('common.status')" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TT_CAPACITY" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('common.createBy')" prop="createName">
                  <!-- 创建人 -->
                  <el-input v-model.trim="queryCondition.createName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="supplierCode">
                  <!-- 供应商编码/邀请码' -->
                  <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('capacity.supplierNameShort')" prop="supplierNameShort">
                    <!-- 供应商简称 -->
                    <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="createDate">
                    <el-date-picker v-model="queryCondition.createDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsStart" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="createEndDate">
                    <el-date-picker v-model="queryCondition.createEndDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsEnd" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category1')" prop="category1">
                    <el-select v-model="queryCondition.category1" clearable @change="changeCategory1()" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.Category2')" prop="category2">
                    <el-select v-model="queryCondition.category2" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row" v-if="emplFlag != 'SUP'">
      <el-button size="mini" class="btn" type="primary" @click="addCapacity()">{{$t('common.newBuilt')}}</el-button>
      <el-button size="mini" class="btn" type="primary" @click="download">{{$t('common.download')}}</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column fixed sortable type="selection" width="55" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="serialNo" :label="$t('capacity.capacityNumber')">
        <!--产能编号-->
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{scope.row.serialNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip v-if="emplFlag != 'SUP'" prop="statusI18n" :label="$t('common.status')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="categoryName1" :label="$t('supplierManage.Category1')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="categoryName2" :label="$t('supplierManage.Category2')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.startDate')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="updateDate" :label="$t('capacity.updateDate')"></el-table-column>
      <el-table-column show-overflow-tooltip v-if="emplFlag == 'SUP'" prop="supplierStatusI18n" :label="$t('capacity.supplierStatusI18n')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createName" :label="$t('common.createBy')"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import capacityApi from "@/api/capacity/capacity";
import { apiService } from "@/api/material/material-master-data";
export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        supplierCode: '',
        supplierNameShort: '',
        createName: '',
        createDate: "",
        createEndDate: '',
        serialNo: '',
        status: '',
        category1: '',
        category2: '',
        status: '',
        createBy: '',
        pageNum: 1,
        pageSize: 15,
      },
      tableList: [],
      categoryList1: [],
      categoryList2: [],
      emplFlag: '',
      // pickerOptionsStart: {
      //   // 开始时间小于结束时间
      //   disabledDate: time => {
      //     let endTime = this.queryCondition.createEndDate;
      //     if (endTime) {
      //       return time.getTime() > new Date(endTime).getTime();
      //     }
      //   }
      // },
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     let beginTime = this.queryCondition.createDate;
      //     if (beginTime) {
      //       return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
      //     }
      //   }
      // },
    };
  },
  created() {
    this.queryData();
    this.getCategoryList()
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      capacityApi.getList(this.queryCondition).then(res => {
        this.tableList = res.data.resultData;
        this.totalCount = res.data.totalCount;
      });
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        supplierCode: '',
        supplierNameShort: '',
        createName: '',
        createDate: "",
        createEndDate: '',
        serialNo: '',
        status: '',
        category1: '',
        category2: '',
        status: '',
        createBy: '',
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    toDetail(row) {
      let ttCapacityId = row.ttCapacityId
      if (row.status == 'new') {
        this.$router.push({
          path: `/addCapacity`,
          query: { ttCapacityId: ttCapacityId },
        });
      } else {
        this.$router.push({
          path: `/capacityDetail`,
          query: { ttCapacityId: ttCapacityId },
        });
      }

    },
    addCapacity() {
      this.$router.push({
        path: `/addCapacity`,
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        console.log(res.data, 'categoryList1')
      });
    },
    download() {
      capacityApi.download(this.queryCondition).then(res => {

      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.category2 = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.category1 }).then((res) => {
        this.categoryList2 = res.data;
        console.log(res.data, 'categoryList2')
      });
    },
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.capacityList .createDateArr .el-form-item__content {
  display: flex;
}
</style>
